import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { CustomDayInterface } from '../interfaces/custom-day.interface';
import { CustomDayTypeEnum } from '../enums/custom-day-type.enum';
import { ReservationRuleInterface } from '../interfaces/reservation-rule.interface';
import { CalenderEventsResponseInterface } from '../interfaces/calendar-events-response.interface';

@Injectable()
export class TechnicsService {
  private readonly url: string;

  constructor(private http: HttpClient) {
    this.url = `${environment.CALENDAR_ADAPTER_URL}`;
  }

  getCalendarEvents(year: string, calendarEventType?: CustomDayTypeEnum): Observable<CalenderEventsResponseInterface> {
    const params = { year };

    if (calendarEventType) {
      params['calendarEventType'] = calendarEventType;
    }

    return this.http.get<CalenderEventsResponseInterface>(this.url + '/calendar-events', {
      params
    });
  }

  addDay(day: Partial<CustomDayInterface>) {
    return this.http.post(this.url + '/calendar-events', day);
  }

  deleteDay(id: string) {
    return this.http.delete(this.url + '/calendar-events/' + id);
  }

  saveConfig(id: string, rule: Partial<ReservationRuleInterface>) {
    return this.http.put(this.url + '/technic-reservation-rules/' + id, rule);
  }

  getReservationRules(): Observable<ReservationRuleInterface[]> {
    return this.http.get<ReservationRuleInterface[]>(this.url + '/technic-reservation-rules');
  }
}



// WEBPACK FOOTER //
// ./src/app/services/technics.service.ts